var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShapemobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 157,
    height: 101,
    viewBox: "0 0 157 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.13398,
    y: 0.133984,
    width: 154.732,
    height: 99.732,
    stroke: "#005CFF",
    strokeWidth: 0.267969
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.746 100.065L0.991211 0.243469M155.746 100.065L0.991211 7.38633M155.746 100.065L0.991211 14.5292M155.746 100.065L0.991211 21.672M155.746 100.065L0.991211 28.8149M155.746 100.065L0.991211 35.9578M155.746 100.065L0.991211 43.1006M155.746 100.065L0.991211 50.2435M155.746 100.065L0.991211 57.3863M155.746 100.065L0.991211 64.5292M155.746 100.065L0.991211 71.672M155.746 100.065L0.991211 78.8149M155.746 100.065L0.991211 85.9578M155.746 100.065L0.991211 93.1006M155.746 100.065L0.991211 99.9046",
    stroke: "#005CFF",
    strokeWidth: 0.267969
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapemobile);
export default __webpack_public_path__ + "static/media/shape.mobile.080bac43c178048d3c55965ebc040f98.svg";
export { ForwardRef as ReactComponent };